import { render } from "./PacienteConvenioRelatorio.vue?vue&type=template&id=65a39d8b&scoped=true"
import script from "./PacienteConvenioRelatorio.vue?vue&type=script&lang=js"
export * from "./PacienteConvenioRelatorio.vue?vue&type=script&lang=js"

import "./PacienteConvenioRelatorio.vue?vue&type=style&index=0&id=65a39d8b&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a39d8b"]])

export default __exports__